/* global gapi */
import React, { useRef, useEffect } from 'react'
import { Auth, useGlobalContext } from 'app'
import { GoogleLogin } from '@react-oauth/google'

export const GoogleLoginButton = () => {
  const loginHelper = Auth.useGoogleLoginHelper()
  const { setGoogleLoginDomRef } = useGlobalContext()
  const containerRef = useRef(null)


  useEffect(() => {
    // Wait for the button to be rendered inside the container
    const button = containerRef.current?.querySelector('div[id$="-overlay"]')
    if (button) {
      setGoogleLoginDomRef(button) // Store the real DOM button globally
    }
  }, [])

  return <span ref={containerRef}>
    <GoogleLogin 
      onSuccess={credentialResponse => loginHelper.onSuccess(credentialResponse.credential)}
      onError={loginHelper.onError}
    />
  </span>

}